export default "__VITE_ASSET__DNkKkX6k__"